// extracted by mini-css-extract-plugin
export var addButton = "_5j-d";
export var bullets = "_5j-e";
export var compact = "_5j-2";
export var container = "_5j-j";
export var extendedWarrantyModal = "_5j-f";
export var learn = "_5j-l";
export var learnMore = "_5j-g";
export var offeringOption = "_5j-3";
export var offeringPrice = "_5j-8";
export var offeringSubtitle = "_5j-7";
export var offeringTitle = "_5j-6";
export var offeringsContainer = "_5j-0";
export var pdpTilesBackground = "_5j-n";
export var plan = "_5j-m";
export var regular = "_5j-1";
export var remove = "_5j-k";
export var seeDetailsIcon = "_5j-i";
export var seeDetailsLink = "_5j-h";
export var selectedOption = "_5j-4";
export var shieldIcon = "_5j-b";
export var shieldIconCompact = "_5j-c";
export var subtitle = "_5j-a";
export var title = "_5j-9";
export var unselectedOption = "_5j-5";